import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

const inputHover = {
  border: `1px solid ${themesConfig.default.colors['grey-100']}`,
  cursor: 'pointer !important',
}

const inputFocus = {
  boxShadow: `0px 0px 2px 1px ${themesConfig.default.colors.secondary}`,
  border: `1px solid ${themesConfig.default.colors.secondary}`,
  cursor: 'text !important',
}

export default makeStyles(() => ({
  root: {
    height: '100%',
    cursor: 'pointer',
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      fontSize: 16,
      lineHeight: 'normal',
      color: themesConfig.default.colors['dove-gray'],
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      borderRadius: 1,
      padding: '8px 6px',
      '&:hover': {
        ...inputHover,
      },

      '&:focus': {
        ...inputFocus,
      },
    },
  },

  select: {
    marginTop: 15,
    maxHeight: 300,
    '& .MuiListItem-gutters': {
      fontSize: 14,
      paddingLeft: 24,
      color: themesConfig.default.colors.primary,
      lineHeight: '20px',
    },
  },

  cellInput: {
    width: '100%',
    color: themesConfig.default.colors['dove-gray'],
    fontSize: 16,
    backgroundColor: 'transparent',
    borderRadius: 1,
    padding: '8px 6px',
    border: `1px solid transparent`,
    '&:hover': {
      ...inputHover,
    },

    '&:focus': {
      ...inputFocus,
    },
  },
}))
